<template>
    <div>
      <banner-top :text="titletext"></banner-top>
      <div class="main">
        <el-form>
          <el-form-item
            style="border-bottom: 1px solid #DFDFDF;"
          >
            <el-row>
              <el-col :span='6'>
                  <div class="size">原密码</div>
              </el-col>
              <el-col class="inputpass" :span='18'>
                <el-input
                  v-model="data.old"
                  type="password"
                  placeholder='请输入原密码'
                ></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item
            style="border-bottom: 1px solid #DFDFDF;"
          >
            <el-row>
              <el-col :span='6'>
                  <div class="size">新密码</div>
              </el-col>
              <el-col class="inputpass" :span='18'>
                <el-input
                  v-model="data.new"
                  type="password"
                  placeholder='请输入新密码'
                ></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item
            style="border-bottom: 1px solid #DFDFDF;"
          >
            <el-row>
              <el-col :span='6'>
                  <div class="size">确认密码</div>
              </el-col>
              <el-col class="inputpass" :span='18'>
                <el-input
                  v-model='again'
                  type="password"
                  placeholder='请再次输入新密码'
                ></el-input>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
        <div class="nav">
          <button @click="out">确认修改</button>
        </div>
      </div>
    </div>
</template>

<script>
import bannerTop from '../components/BannerTop.vue'
import http from '../utils/http'

export default {
  name: 'modification',
  components: { bannerTop },
  data () {
    return {
      titletext: '修改密码',
      data: {
        old: '',
        new: ''
      },
      again: ''
    }
  },
  methods: {
    out () {
      if (this.data.new !== this.again) {
        this.$message.error('两次密码输入不一致')
      } else {
        http['put']('account/password', this.data)
        this.$router.push({name: 'mine'})
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main {
    padding: 10%;
    width: 80%;
    height: 14rem;
}
.iconimg {
    width: 30px;
    height: 30px;
    margin-left: 10px;
}
.size {
    font-size: 17px;
    font-weight: 400;
}
.inputpass>>>.el-input__inner {
    border: 0;
    font-size: 17px;
}
.nav {
  width: 100%;
  height: 3.2rem;
  margin: 10%;
}
.nav button {
    width: 80%;
    height: 2.8rem;
    background: #ffb949;
    border-radius: 44px;
    border: 0;
    color: #fff;
    font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/mine/modification.vue